<template>
  <router-view />
</template>

<script>
export default {
    name:"OperationsMain"
}
</script>
